import { WATER_TESTING_MAP_PINS_QUERY } from '../data-access/water-testing-map-pins'
import { BaseQuery } from './BaseQuery'
import {
  waterTestingMapPins,
  waterTestingMapPinsVariables
} from '../data-access/__generated__/types'

export class WaterTestingMapPinsQuery extends BaseQuery<
  waterTestingMapPins,
  waterTestingMapPinsVariables
> {
  query = WATER_TESTING_MAP_PINS_QUERY
}
